/* ==========================================================================
   COGNITIVE PRIME — TSL v9

   The tiles are the only buy buttons on the page. Clicking one adds that pack
   and goes straight to checkout. There is no standalone Add to Cart button.

   The Subscribe & Save toggle sits BELOW the tiles. It still governs what gets
   sent — the tile prices, the save badges and the selling plan all follow it —
   but a buyer who clicks a tile before scrolling to it will purchase on the
   default, which is subscription ON.

   EDIT VARIANT + SELLING PLAN IDS HERE, NOWHERE ELSE.
   ========================================================================== */
(function(){
  var root=document.getElementById('cp6'); if(!root) return;

  var CP={
    variants:{'1':'47590093881534','3':'47590093914302','6':'47590093947070'},
    plans:{'1':'15569387710','3':'15569486014','6':'15569518782'}
  };

  var sub=true;
  var tiers=[].slice.call(root.querySelectorAll('.co-tier'));

  function money(v){return '$'+Number(v).toFixed(2)}
  /* cents math — 43.99 * 3 is 131.96999999999998 in float */
  function total(each,n){return Math.round(each*100)*n/100}
  function whole(v){return '$'+Math.round(v)}

  function render(){
    tiers.forEach(function(t){
      var n=Number(t.dataset.qty),
          one=Number(t.dataset.one),
          each=sub?Number(t.dataset.sub):one;

      t.querySelector('[data-each]').textContent=money(each);

      /* strike-through and save badge only mean anything while subscribed */
      var was=t.querySelector('[data-was]'),
          save=t.querySelector('[data-save]');
      was.style.visibility=sub?'visible':'hidden';
      if(save){
        var diff=total(one,n)-total(each,n);
        save.textContent='Save '+whole(diff);
        save.classList.toggle('is-hidden',!sub||diff<=0);
      }
    });

    var bar=root.querySelector('[data-subbar]'),
        tog=root.querySelector('[data-toggle]');
    bar.classList.toggle('is-off',!sub);
    tog.setAttribute('aria-checked',sub?'true':'false');
    root.querySelector('[data-subword]').textContent=sub?'on':'off';
  }

  /* clicking a pack buys that pack */
  tiers.forEach(function(t){
    t.addEventListener('click',function(){buy(t.dataset.qty,t)});
  });
  root.querySelector('[data-toggle]').addEventListener('click',function(){sub=!sub;render()});

  /* ---- add to cart ---- */
  var working=false;
  function busy(on,tile){
    working=on;
    tiers.forEach(function(t){t.classList.toggle('is-busy',on&&t!==tile)});
    if(tile)tile.classList.toggle('is-working',on);
  }

  function buy(which,tile){
    if(working) return;
    var v=CP.variants[which], plan=CP.plans[which], err=root.querySelector('[data-err]');
    err.style.display='none';
    if(!v){err.textContent='That supply option is not connected yet.';err.style.display='block';return}
    var item={id:Number(v),quantity:1};
    if(sub&&plan)item.selling_plan=Number(plan);
    busy(true,tile);
    var r=(window.Shopify&&Shopify.routes&&Shopify.routes.root)?Shopify.routes.root:'/';
    fetch(r+'cart/add.js',{
      method:'POST',
      headers:{'Content-Type':'application/json','Accept':'application/json'},
      body:JSON.stringify({items:[item]})
    })
    .then(function(x){if(!x.ok)return x.json().then(function(d){throw d});return x.json()})
    .then(function(){window.location.href=r+'checkout'})
    .catch(function(e){
      busy(false,tile);
      err.textContent=(e&&e.description)?e.description:'We could not add that to your cart. Please try again.';
      err.style.display='block';
    });
  }

  /* ---- supplement facts modal ---- */
  (function(){
    var lb=root.querySelector('[data-lb]'),
        open=root.querySelector('[data-facts]'),
        close=root.querySelector('[data-lb-close]');
    if(!lb||!open) return;
    var lastFocus=null;
    function show(){
      lastFocus=document.activeElement;
      lb.classList.add('open');
      document.body.style.overflow='hidden';
      close.focus();
    }
    function hide(){
      lb.classList.remove('open');
      document.body.style.overflow='';
      if(lastFocus&&lastFocus.focus)lastFocus.focus();
    }
    open.addEventListener('click',show);
    close.addEventListener('click',hide);
    lb.addEventListener('click',function(e){if(e.target===lb)hide()});
    document.addEventListener('keydown',function(e){
      if(lb.classList.contains('open')&&e.key==='Escape')hide();
    });
  })();

  render();
})();
